var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.phones, function(phone, index) {
        return _c("div", { key: index, staticClass: "row gutter-sm" }, [
          _c(
            "div",
            { class: [_vm.phonesNotEmpty ? "col-11" : "col-12"] },
            [
              _c("phone-input", {
                attrs: {
                  value: _vm.phones[index],
                  id: index,
                  label: _vm.label,
                  hideLabel: _vm.hideLabel,
                  showIcon: _vm.showIcon
                },
                on: {
                  input: function($event) {
                    _vm.updatePhone($event, index)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.phonesNotEmpty,
                  expression: "phonesNotEmpty"
                }
              ],
              staticClass: "col-1 text-right"
            },
            [
              _c("q-btn", {
                staticClass: "q-mt-lg",
                attrs: {
                  flat: "",
                  dense: "",
                  icon: "remove_circle",
                  color: "light"
                },
                on: {
                  click: function($event) {
                    _vm.clearPhone(index)
                  }
                }
              })
            ],
            1
          )
        ])
      }),
      _c(
        "div",
        { staticClass: "row justify-end" },
        [
          _c("q-btn", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.phonesNotEmpty,
                expression: "phonesNotEmpty"
              }
            ],
            class: _vm.showControls ? "q-mr-xl" : "",
            attrs: { flat: "", dense: "", label: _vm.$t("additional_phone") },
            on: { click: _vm.addPhone }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }